import React, { useEffect, useState } from 'react';
import DesktopExternal from './externalModule/DesktopExternal.tsx';
import MobileExternal from './externalModule/MobileExternal.tsx';

const External: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 67.5rem)').matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 67.5rem)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    return (
        <div>
            {isMd ? (
                <DesktopExternal />
            ) : (
                <MobileExternal />
            )}
        </div>
    );
};

export default External;